import * as browserCheck from '../utils/browserCheck.js';

export default {
    artistState: {
        featuredArtists: [],
        profiles: [],
        profileLoadingStatus: [],
        browse: {
            roleType: '',
            selectedTab: 'browse',
            keyword: '',
            searchError: '',
            browseError: '',
            searchCriteria: {
                selectedGenres: [],
                selectedAssociations: [],
                selectedCapacity: '',
                sort: '',
                location: [],
                distance: '',
                distanceUnit: '',
                instrument: '',
                expertise: ''
            },
            loadingStatus: null,
            results: {
                lastPage: 0,
                haveNextPage: false,
                items: [],
                selectedTab: '',
                searchCriteria: null,
                keyword: '',
                roleType: { }
            }
        },
        createProfileError: null,
    },
    trackState: {
        featuredTracks: [],
        selectedTrack: null,
        nowPlaying: {},
        trackPlaying: false,
        trackPaused: false,
        charts: [],
        chartLoadingStatus: null,
        chartsLastLoaded: null,
        trackPlayed: false
    },
    videoState: {
        selectedVideo: null,
        charts: [],
        chartLoadingStatus: null,
        chartsLastLoaded: null
    },
    accountState: {
        token: null,
        tokenExpiry: null,
        user: null,
        userLoading: false,
        activeProfileID: null,
        loginError: null,
        signupError: null,
        newSignup: false,
        soundCloudToken: null
    },
    gigState: {
        gig: null,
        gigLoadingStatus: null,
        browse: {
            selectedTab: 'browse',
            keyword: '',
            searchError: '',
            browseError: '',
            searchCriteria: {
                selectedGenres: [],
                sort: '',
                location: [],
                distance: '',
                distanceUnit: '',
                startDate: null,
                endDate: null
            },
            loadingStatus: null,
            results: {
                lastPage: 0,
                haveNextPage: false,
                items: [],
                selectedTab: '',
                searchCriteria: null,
                keyword: ''
            }
        }
    },
    genreState: [],
    instrumentState: [],
    locationState: {
        countries: []
    },
    activityState: {
        activityFeed: [],
        loadingStatus: null,
        lastLoaded: null
    },
    blogState: {
        general: {
            items: [],
            selectedSections: [],
            selectedTags: [],
            lastPage: 0,
            haveNextPage: false,
            loadingStatus: null,
            sections: [],
            tags: []
        },
        unsigned: {
            items: [],
            selectedSections: [],
            selectedTags: [],
            lastPage: 0,
            haveNextPage: false,
            loadingStatus: null,
            sections: [],
            tags: []
        },
        discover: {
            items: [],
            selectedSections: [],
            selectedTags: [],
            lastPage: 0,
            haveNextPage: false,
            loadingStatus: null,
            sections: [],
            tags: []
        },
        article: null,
        articleLoadingStatus: null
    },
    discussionState: {
        sections: [],
        currentDiscussion: null
    },
    modalState: {
        showModal: false,
        //modalContent: null,
        modalType: null
    }
};